import React from "react";
import ButtonGroup from "@mui/material/ButtonGroup";
import { Button } from "@ADC/components/common";

const Step2 = ({
  handleChange,
  setFormError,
  formError,
  values,
  setStep,
  step,
}) => {
  return (
    <div>
      <h2 className="text-[35.02px] md:text-[45.3px] leading-[40.35px] md:leading-[52.19px] text-[#2C6BB3] font-bold">
        Are you a Texas Resident?
      </h2>
      <ButtonGroup className="gap-4 mt-8 mb-12">
        <button
          className="font-bold py-2 px-4 rounded border border-green-700 hover:bg-green-700 focus:bg-green-700 focus:text-white active:bg-green-700 text-green-700 active:text-white hover:text-white hover:scale-110 transform transition-all duration-500 ease-in-out"
          onClick={() => {
            const e = {
              target: {
                name: "liveInTexas",
                value: "Yes",
              },
            };
            handleChange(e);
          }}
        >
          Yes
        </button>
        <button
          className="font-bold py-2 px-4 rounded border border-green-700 hover:bg-green-700 focus:bg-green-700 focus:text-white active:bg-green-700 text-green-700 active:text-white hover:text-white hover:scale-110 transform transition-all duration-500 ease-in-out"
          onClick={() => {
            const e = {
              target: {
                name: "liveInTexas",
                value: "No",
              },
            };
            handleChange(e);
          }}
        >
          No
        </button>
      </ButtonGroup>
      {formError.liveInTexas ? (
        <p className="w-full flex justify-center items-center mb-4 text-lg font-semibold text-red-800">
          {formError.liveInTexas}
        </p>
      ) : null}
      <Button
        className="!py-1 !px-3 !rounded-lg !text-xl w-60 mx-auto"
        label="Continue"
        variant="primary"
        onPress={(e) => {
          if (values.liveInTexas) {
            if (step < 3) setStep(step + 1);
          } else {
            setFormError({
              ...formError,
              liveInTexas: "Please select one option.",
            });
          }
        }}
      />
    </div>
  );
};

export default Step2;
